import React,{useContext,useState,useEffect } from "react";
import defaultImage from "../../assets/default_music.png";
import TrackContext from "../../contexts/track-context";
import { Pause } from "@material-ui/icons";
import { PlayArrow } from "@material-ui/icons";
import Helper from "../../services/helper";

const PlaylistTile = (props) => {
    const trackContext = useContext(TrackContext);
    const {tracks,setPlayAll,pageId}=props;
const [marginTop, setMarginTop] = useState("20px");
    useEffect(()=>{
      //to show play or pause button 
      let index=tracks?.findIndex((track)=> track.id === trackContext.currentTrackDetail.id)
      if(index !== -1 && index!==undefined  && trackContext.playPause && trackContext.playingFrom === pageId){
        setPlayAll(true)
      }
      else {
        setPlayAll(false)
      }
         
// set the margin of playbutton

const updateMargin = () => {
  if (window.innerWidth < 768) {
    setMarginTop("-10px"); // Mobile view
  } else if (window.innerWidth < 1024) {
    setMarginTop("-50px"); // Tablet view
  } else {
    setMarginTop("-70px"); // Desktop view
  }
};

updateMargin(); // Set initial value
window.addEventListener("resize", updateMargin);

return () => {
  window.removeEventListener("resize", updateMargin);
}
    },[trackContext.playPause,tracks])

  return (
    <>
     <div className="pb-3 border-b lg:mt-0 mt-12">
      <div className="w-full flex flex-wrap mt-10">
      <div className="w-full row flex flex-col gap-y-2 md:flex-row md:gap-y-0 py-6 md:py-2">
        <div className="w-full lg:w-2/6 rounded-md">
          {props.playlistDetails?.image?.large?.url && (
            <img
               className="w-full rounded-md"
              onError={(e) => trackContext.setDefaultImage(e)}
              src={props.playlistDetails?.image?.large?.url || defaultImage}
              alt="playlistInfo"
            />
          )}
        </div>
        <div className="w-full lg:w-4/6 px-3 text-left lg:pl-10">
          <h1 className="mb-2 text-xl" >{props.playlistDetails?.title}</h1>
          {/* <p>Playlist by 
            <b> {props?.playlistDetails?.created_by?.first_name} {props?.playlistDetails?.created_by?.last_name} ({props?.playlistDetails?.created_by?.company_name})</b>
          </p>
          {props?.playlistDetails?.created_at && 
            <p>Creatd on 
              <b> {new Date(props?.playlistDetails?.created_at).toDateString()}</b>
            </p>
          } */}
          {props.playlistDetails?.descriptions && (
            <p className="mb-2 text-description self-center text-all w-full lg:w-3/5 text-justify ">
              {props.playlistDetails?.descriptions[0]?.value}
            </p>
          )}
          
        </div>  
        </div>     
      </div>
      <div className="row flex mb-4" style={{marginTop}}>
        <div className="w-0 sm:w-2/6 "></div>
        <div className="w-full lg:w-4/6 px-3 pl-2 sm:pl-10 ">
        {
          props.tracks.length ?
          (
            <div className=" cursor-pointer">
          {(!props.playAll || !trackContext.playPause) ? (
            <button  className="album-play-button" onClick={props.playPlaylistTracks}>
              <span>
                <PlayArrow className="outline-none cursor-pointer" />
              </span>
              <span>Play</span>
            </button>
          ) : (
            <button className="album-pause-button" onClick={props.handlePause}>
              <span>
                <Pause className="outline-none cursor-pointer hover:bg-pink-500 " />
              </span>
              <span>Pause</span>
            </button>
          )}
        </div>
          ):null
        }
        </div>
      </div>
    </div>
      
    </>
  );
};

export default PlaylistTile;